import { Chip, Badge as BadgeComponent } from '@mui/material'
import { styled } from '@mui/material/styles'

const ChipCustom = styled(Chip)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontSize: '0.985em',
  height: '18px',
  fontWeight: 600,
  backgroundColor: 'rgb(25 118 210 / 9%)',
  color: '#000',
}))

const Badge = styled(BadgeComponent)(props => ({
  '& .MuiBadge-badge': {
    color: props.colortext ?? '#000',
    backgroundColor: props.backgroundcolor ?? 'transparent',
    fontSize: '0.68rem',
    height: '14px',
    minWidth: '14px',
    width: '14px',
    fontWeight: 650,
    border: props.border ?? 'transparent',
  },
}))

const ChipCustomTg = ({
  label,
  badgeContent,
  badgeBackground,
  badgeBorder,
  badgeColor,
  badgeAnchorOrigin,
  ...rest
}) => {
  return (
    <Badge
      badgeContent={badgeContent}
      anchorOrigin={badgeAnchorOrigin}
      backgroundcolor={badgeBackground}
      border={badgeBorder}
      colortext={badgeColor}>
      <ChipCustom label={label} sx={{ ...rest }} />
    </Badge>
  )
}

export default ChipCustomTg
